<template>
<v-select ref="type" :loading="loading" :value="value" :items="items" item-text="title" item-value="value" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="v => $emit('input', v)" @change="v => $emit('input', v)">
</v-select>
</template>

<script>
//
export default {
  name: 'MyLendingType',
  props: {
    value: {
      // type: String,
      required: true,
    },
    route: {},
  },
  mounted() {
    if (this.refs === true) {
      this.$refs.type.focus()
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  methods: {
    async retrieveData() {
      //
      this.loading = true
      try {
        this.items = [{
          value: 'rec',
          title: 'دریافت'
        }, {
          value: 'pay',
          title: 'پرداخت'
        }]
        //
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
}
</script>
